import React, { useState, useEffect, useCallback } from 'react';
import { Container, Row, Col, InputGroup } from 'react-bootstrap';
import { axiosInstance } from 'src/api/axios';
import { HttpSuccessCodes } from 'src/Admin/errorhandling/HttpErrorCodes';
import AddButton from 'src/Admin/components/User/UserFormNew/components/AddButton';
import FilterModal from 'src/Admin/components/common/filter-modal/FilterModal';
import { SearchSVG } from 'src/Admin/img/GlobalSVG';
import TextInput from 'src/Components/GenericInputText/TextInput';
import APIEndpoints from '../../../../../../api/APIEndpoints';
import Lists from '../Lists';
import SearchIndicationPage from '../../../../SearchIndicationPage';
import debounce from 'lodash.debounce';
import Skeleton from 'src/Admin/components/common/skeleton';

const FacilityPanel = ({
  label,
  deleteBrokerId,
  onSelectedItemsHandler,
  createUserFormData,
  onSelectAllItems,
  selectedItemsData,
  editAffiliatedRecords,
  selectedFacilities,
}) => {
  const cacheBuster = (url) => `${url}?cb=${Date.now()}`;

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [facilityData, setFacilityData] = useState(null);
  const [facilityDetailsData, setFacilityDetailsData] = useState([]);
  const [selectedFacilityData, setSelectedFacilityData] = useState([]);
  const [unCheckedItem, setUnCheckedItem] = useState([]);
  const [searchString, setSearchString] = useState('');
  const [searchText, setSearchText] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [loadingPage, setLoadingPage] = useState(true);
  const [customError, setCustomError] = useState(false);
  const [dataFetching, setDataFetching] = useState(false);
  let SearchFacilityListResponse = null;
  let SearchFacilityListDataResp = null;
  //let pageRecordsCount = 10;

  const debouncedCall = useCallback(
    debounce((currentVal) => setSearchText(currentVal), 500),
    [],
  );

  const onChangeSearchTerm = (e) => {
    setDataFetching(true);
    setSearchString(e.target.value);
    //setSearchText(e.target.value)
    debouncedCall(e.target.value);
    setCurrentPage(1);
    setUnCheckedItem([]);
    //searchFacilityList(searchString, currentPage)
  };

  const applyFilterHandler = () => {
    //console.log("unCheckedItem Items:::::::  ", unCheckedItem);
    console.log('applyFilterHandler facilityDetailsData', facilityDetailsData);
    const selectedFacilities = facilityDetailsData.filter(
      (facility) => facility.isChecked == true,
    );
    onSelectedItemsHandler(selectedFacilities, unCheckedItem);
    //onSelectedItemsHandler( selectedFacilities , unCheckedItem);
    //onUnSelectedItemsHandler( unCheckedItem );
    //console.log('applyFilterHandler selectedFacilityData', selectedFacilityData)
    //onSelectedItemsHandler( selectedFacilityData );

    setIsModalOpen(false);
    setSearchString('');
    setUnCheckedItem([]);
  };

  const selectChangeHandler = (e) => {
    console.log('e.target=====', e.target);
    const { name, checked } = e.target;
    //const temp = [];
    if (name === 'select-all-facility') {
      const tempFacility = facilityDetailsData.map((facility) => {
        return { ...facility, isChecked: checked };
      });
      setFacilityDetailsData(tempFacility);
    } else {
      const tempFacility = facilityDetailsData.map((facility) =>
        facility.FacilityOID === name
          ? { ...facility, isChecked: checked }
          : facility,
      );
      console.log('tempFacility', tempFacility);
      setFacilityDetailsData(tempFacility);
      if (checked === false) {
        setUnCheckedItem([...unCheckedItem, name]);
      }

      if (checked === true) {
        console.log('Checked true ::::::::  ', unCheckedItem);
        const tempSel = unCheckedItem.filter((item) => item !== name);
        console.log('tempSelec :::::::: ', tempSel);
        setUnCheckedItem(tempSel);
      }

      /*const selectedTempFacilities = tempFacility.filter( ( facility ) => facility.isChecked == true );
      console.log('checkbox selectedTempFacilities', selectedTempFacilities);
      //console.log('checkbox selectedFacilityData', selectedFacilityData);
      const facilities = [...selectedFacilityData, ...selectedTempFacilities];
      //const allFacilities =[...facilities, selectedFacilityData]
      console.log('facilities', facilities);*/
      /*setSelectedFacilityData(facilities);*/
      //setSelectedFacilityData([...selectedFacilityData, ...selectedTempFacilities]);
      //onSelectAllItems( tempFacility );
    }

    /*const { name, checked } = e.target;
    if ( name === 'select-all-facility' ) {
      const tempFacility = facilityDetailsData.map( facility => {
        return {...facility, isChecked: checked};
      } );
      setFacilityDetailsData( tempFacility );
      onSelectAllItems( tempFacility );
    } else {
      const tempFacility = facilityDetailsData.map( facility => facility.FacilityID === name ? {...facility, isChecked: checked} : facility );
      setFacilityData( tempFacility );
      onSelectAllItems( tempFacility );
    }*/
  };

  /*const getBrokerData = async () => {
    try {
      const BrokersListResponse = await axiosInstance.get(
        cacheBuster( APIEndpoints.getAllBrokers() ),
      );
      if ( BrokersListResponse.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_200 ) {
        if ( BrokersListResponse?.data?.Response?.BrokerDemographic ) {

          if ( selectedItemsData && selectedItemsData.length > 0 ) {
            const brokerList = BrokersListResponse?.data?.Response?.BrokerDemographic;
            const tempObj = brokerList
              .map( item =>  selectedItemsData
                .filter( selectedItem => Boolean( selectedItem.Code === item.Code ) )
                .length ?
                {...item, 'isChecked': true}
                : item );
            setFacilityData( tempObj );
            onSelectAllItems( tempObj );
          } else {
            setFacilityData( BrokersListResponse?.data?.Response?.BrokerDemographic );
            onSelectAllItems( BrokersListResponse?.data?.Response?.BrokerDemographic );
          }
        }
      }

    } catch ( error ) {
      console.log( error );
    }
  };*/

  //useEffect( () => {
  //if ( deleteBrokerId ) {
  //const tempBrokerData = facilityData.map( facility => facility.FacilityOID === deleteBrokerId ? {...facility, isChecked: false} : facility );
  //const checkedBrokerData = tempBrokerData.filter( ( facility ) => facility.isChecked == true );
  //onSelectedItemsHandler( checkedBrokerData );
  //setFacilityData( tempBrokerData );
  //onSelectAllItems( tempBrokerData );
  //}
  ////else {
  ////createUserFormData && createUserFormData.allBrokers.length > 0 &&
  ////setFacilityData( createUserFormData.allBrokers );
  //////: getBrokerData();
  ////}
  //}, [ deleteBrokerId, selectedItemsData ] );

  //console.log( 'facilityData', facilityData );

  const showMoreFacilityData = () => {
    setCurrentPage(currentPage + 1);
    //searchFacilityList(searchString, currentPage);
  };

  const searchFacilityList = async (searchString, currPage) => {
    setDataFetching(true);
    setFacilityDetailsData([]);
    try {
      //let activePageSize;
      let strSearchKey = '';
      if (searchString && searchString.length < 3) {
        setFacilityData(null);
        setFacilityDetailsData([]);
        setCurrentPage(1);
        //activePageSize = pageRecordsCount;
        //return []
        setLoadingPage(false);
      } else {
        if (searchString && searchString.length >= 3) {
          setCustomError(false);
          strSearchKey = 'searchkey/' + searchString;
          console.log('strSearchKey', strSearchKey);
          //activePageSize = pageRecordsCount * currPage;
          SearchFacilityListResponse = await axiosInstance.get(
            cacheBuster(
              APIEndpoints.getFacilityListResources() +
                strSearchKey +
                '/pagesize/10/pagenumber/' +
                currPage,
            ),
          );

          /*SearchFacilityListResponse = await axiosInstance.get(
              cacheBuster( APIEndpoints.getFacilityListResources() + strSearchKey+ '/pagesize/'+ activePageSize +'/pagenumber/'+ currPage) );
            */
          SearchFacilityListDataResp = SearchFacilityListResponse.data;

          if (
            SearchFacilityListResponse.status ===
            HttpSuccessCodes.HTTP_SUCCESS_CODE_200
          ) {
            setFacilityData(SearchFacilityListDataResp.Response);
            console.log(
              'FACILITY RESPONSE',
              SearchFacilityListDataResp.Response,
            );

            if (selectedFacilities && selectedFacilities.length > 0) {
              SearchFacilityListDataResp.Response.FacilityDetails.forEach(
                (f) => {
                  selectedFacilities.forEach((s) => {
                    if (f.FacilityOID === s.FacilityOID) {
                      f.isChecked = true;
                      console.log('response facilties======', f);
                    }
                  });
                },
              );
              setFacilityDetailsData(
                SearchFacilityListDataResp.Response.FacilityDetails,
              );
              console.log(
                'SearchFacilityListDataResp checked',
                SearchFacilityListDataResp.Response.FacilityDetails,
              );
            }
            //else {
            if (currPage === 1) {
              setFacilityDetailsData(
                SearchFacilityListDataResp.Response.FacilityDetails,
              );
            } else {
              setFacilityDetailsData([
                ...facilityDetailsData,
                ...SearchFacilityListDataResp.Response.FacilityDetails,
              ]);
            }
            //}
            //setFacilityDetailsData(SearchFacilityListDataResp.Response.FacilityDetails)
          }

          //setFacilityDetailsData(SearchFacilityListDataResp.Response.FacilityDetails)
        }
      }
      setDataFetching(false);
    } catch (error) {
      console.log('error', error);
      setLoadingPage(false);
      setCustomError(true);
      setDataFetching(false);
      setFacilityDetailsData([]);
    }
  };

  useEffect(() => {
    if (searchText === searchString) {
      searchFacilityList(searchText, currentPage);
    }
  }, [searchText, currentPage, searchString]);

  console.log('facilityData', facilityData);
  console.log('facilityDetailsData', facilityDetailsData, dataFetching);

  console.log('facilityData', facilityData);
  console.log('unCheckedItem Child:::::::::  ', unCheckedItem);

  return (
    <>
      {editAffiliatedRecords ? (
        <AddButton
          label={label}
          onClick={() => {
            setIsModalOpen(true);
          }}
          className={'add-button-active'}
        />
      ) : (
        <AddButton label={label} className={'add-button-disable'} />
      )}
      <FilterModal
        showBackButton={false}
        isVisible={isModalOpen}
        onHide={() => {
          setSearchString('');
          setSearchText('');
          setIsModalOpen(false);
          setFacilityData(null);
          setFacilityDetailsData([]);
          setCurrentPage(1);
          setUnCheckedItem([]);
          setCustomError(false);
          setLoadingPage(true);
        }}
        applyFilterHandler={applyFilterHandler}
        showCancel={true}
        titleLabel="Facility"
        showApply={true}
        showApplyLabel="Add Selected"
      >
        <Container className="mt-3 mb-3">
          <Row>
            <Col sm={12}>
              <div>
                <TextInput
                  parentClassName="mb-2"
                  label="Facility"
                  append={
                    <InputGroup.Text>
                      <SearchSVG.SearchSVG className="primary-text-color" />
                    </InputGroup.Text>
                  }
                  inputProps={{
                    type: 'text',
                    placeholder: 'Search by Name, Tax ID, or Address',
                    value: searchString,
                    onChange: onChangeSearchTerm,
                    className: 'border-right-0',
                    autoFocus: false,
                    id: 'filter-broker-input',
                  }}
                />
              </div>
            </Col>
          </Row>
          {/*{loadingPage && !customError && searchString.length >=3 && (
            <Skeleton count={20} height={30} />
          )} */}
          {facilityDetailsData && searchString.length >= 3 ? (
            <>
              {dataFetching && !customError ? (
                <Skeleton count={20} height={30} />
              ) : (
                <>
                  {facilityDetailsData &&
                  facilityDetailsData.length > 0 &&
                  Object.keys(facilityDetailsData).length > 0 &&
                  !customError ? (
                    <>
                      <Row>
                        <Col sm={12} className="mt-4 mb-2">
                          <div className=" select-all-row d-flex">
                            <input
                              type="checkbox"
                              id="select-all-facility"
                              name="select-all-facility"
                              className="p-0 mt-auto mb-auto"
                              onChange={(e) => {
                                selectChangeHandler(e);
                              }}
                              /*checked={
                      createUserFormData && createUserFormData.allBrokers.length > 0 ?
                        createUserFormData.allBrokers.filter( ( broker ) => broker.isChecked !== true ).length < 1
                        :
                        facilityData.filter( ( broker ) => broker.isChecked !== true ).length < 1
                    }*/
                              checked={
                                facilityDetailsData.filter(
                                  (facility) => facility.isChecked !== true,
                                ).length < 1
                              }
                            />
                            <label
                              className="my-auto select-all-checkbox"
                              htmlFor="select-all-blob"
                            >
                              Select All
                            </label>
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col sm={12} className="mb-1">
                          {facilityDetailsData &&
                            facilityDetailsData.length > 0 && (
                              <Lists
                                data={
                                  facilityDetailsData && facilityDetailsData
                                }
                                selectChangeHandler={selectChangeHandler}
                                searchString={searchString}
                              />
                            )}
                        </Col>
                      </Row>
                      <Row className="mt-3 ml-1">
                        {facilityDetailsData &&
                          facilityDetailsData.length <
                            facilityData.Pagination.TotalRecords && (
                            <div
                              className="panel-card-link"
                              onClick={(e) => showMoreFacilityData()}
                              role="button"
                            >
                              Show More
                            </div>
                          )}
                      </Row>
                    </>
                  ) : (
                    <Container className="mt-3 mb-3">
                      <div>No Records Found</div>
                    </Container>
                  )}
                </>
              )}
            </>
          ) : (
            <Container className="mt-3 mb-3">
              <SearchIndicationPage />
            </Container>
          )}
        </Container>
        {/*//  : <Container className="mt-3 mb-3"><div>No Records Found</div></Container>
        //}*/}
        {/*// {!dataFetching && facilityDetailsData && Object.keys( facilityDetailsData ).length == 0 && searchString.length > 3 &&
        //   <Container className="mt-3 mb-3"><div>No Records Found</div></Container>
        // } */}
      </FilterModal>
    </>
  );
};

export default FacilityPanel;
